import '../Main.scss';

import IconButton from '@mui/material/IconButton';

import * as React from 'react';

import { PortalTextPaginationControls } from '../../Models/Api/strongbox.financialportal';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faChevronRight,
    faChevronLeft,
    faChevronsRight,
    faChevronsLeft,
} from '@awesome.me/kit-8a0d2fd588/icons/modules/sharp/light';
import { InlineStylingValues } from '../../Utils/Constants';

type Props = {
    elementsOnPage: number;
    elementsPerPage: number;
    totalElements: number;
    pageNumber: number;
    pageLeft: () => void;
    pageRight: () => void;
    goFirstPage: () => void;
    goLastPage: () => void;
    isOnLastPage: () => boolean;
    /**
     * This control fills it's container's full-width, but the visual part of the component is potentially small.
     * Specify how you want to align the visual elements of the pagination control. The default is 'left'.
     */
    horizontalAligment?: 'left' | 'center' | 'right';
    defaultContainerStyle?: React.CSSProperties;
    paginationText?: PortalTextPaginationControls;
};

export const PaginationControls: React.FC<Props> = (props): React.ReactElement => {
    const {
        defaultContainerStyle,
        isOnLastPage,
        pageNumber,
        paginationText,
    } = props;

    const containerStyle: React.CSSProperties = defaultContainerStyle || {};

    switch (props.horizontalAligment) {

        case 'right':
            containerStyle.justifyContent = 'flex-end';
            break;

        case 'center':
            containerStyle.justifyContent = 'center';
            break;

        default:
            containerStyle.justifyContent = 'flex-start';
            break;
    }

    const onLastPage = React.useMemo(() => {
        return isOnLastPage();
    // Current page number very much affects isOnLastPage so it should be in the dependencies list
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOnLastPage, pageNumber]);

    return (
        <div style={containerStyle} className={`pagination-controls-container`}>
            <IconButton
                style={{ marginRight: InlineStylingValues.IconSeparator }}
                className={'pagination-button'}
                aria-label={paginationText?.firstPage || ''}
                onClick={props.goFirstPage}
                disabled={pageNumber === 1}
            >
                <FontAwesomeIcon 
                    icon={faChevronsLeft} 
                />
            </IconButton>

            <IconButton
                style={{ marginRight: InlineStylingValues.IconSeparator }}
                className={'pagination-button'}
                aria-label={paginationText?.pageLeft || ''}
                onClick={props.pageLeft}
                disabled={pageNumber === 1}
            >
                <FontAwesomeIcon 
                    icon={faChevronLeft} 
                />
            </IconButton>
            <span 
                style={{ marginRight: InlineStylingValues.IconSeparator }}
            >
                {` ${paginationText?.page || ''} ${props.pageNumber}`}
            </span>
            <IconButton
                style={{ marginRight: InlineStylingValues.IconSeparator }}
                className={'pagination-button'}
                aria-label={paginationText?.pageRight || ''}
                onClick={props.pageRight}
                disabled={onLastPage}
            >
                <FontAwesomeIcon icon={faChevronRight} />
            </IconButton>

            <IconButton
                className={'pagination-button'}
                aria-label={paginationText?.lastPage || ''}
                onClick={props.goLastPage}
                disabled={onLastPage}
            >
                <FontAwesomeIcon icon={faChevronsRight} />
            </IconButton>

        </div>
    );
}
